export var EShopLinkType;
(function (EShopLinkType) {
    EShopLinkType[EShopLinkType["CATEGORY"] = 1] = "CATEGORY";
    EShopLinkType[EShopLinkType["GOOD"] = 2] = "GOOD";
})(EShopLinkType || (EShopLinkType = {}));
